<template>
  <v-card class="addon-category-card">
    <v-card-title class="d-flex justify-space-between align-center py-4">
      <div class="d-flex align-center">
        <v-icon color="primary" class="mr-3">mdi-shape-outline</v-icon>
        <div>
          <span class="text-h6 font-weight-bold">{{ category.name }}</span>
          <p v-if="category.description" class="text-body-2 text-medium-emphasis mb-0 mt-1">{{ category.description }}</p>
        </div>
      </div>
      <div class="d-flex" style="gap: 8px;">
        <v-btn
          icon
          variant="text"
          size="small"
          @click="$emit('edit-category', category)"
        >
          <v-icon size="20">mdi-pencil</v-icon>
        </v-btn>
        <v-btn
          icon
          variant="text"
          size="small"
          color="error"
          @click="$emit('delete-category', category)"
        >
          <v-icon size="20">mdi-delete</v-icon>
        </v-btn>
      </div>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text class="pa-0">
      <v-data-table
        :headers="headers"
        :items="category.items"
        item-key="id"
        density="comfortable"
      >
        <template #item.price="{ item }">
          <span class="font-weight-medium">${{ item.price.toFixed(2) }}</span>
        </template>
        <template #item.actions="{ item }">
          <div class="d-flex justify-end" style="gap: 4px;">
            <v-btn icon variant="text" size="small" @click="$emit('edit-item', item, category)">
              <v-icon size="18">mdi-pencil</v-icon>
            </v-btn>
            <v-btn icon variant="text" size="small" color="error" @click="$emit('delete-item', category, item)">
              <v-icon size="18">mdi-delete</v-icon>
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script setup>

import { defineProps } from 'vue';

defineProps({
  category: {
    type: Object,
    required: true
  }
});

const headers = [
  { title: 'Name', value: 'name' , align: 'start', sortable: false, width: '30%' },
  { title: 'Price', value: 'price' , align: 'end', sortable: false, width: '10%' },
  { title: 'Note', value: 'note' , align: 'center', sortable: false, width: 'auto' },
  { title: 'Actions', value: 'actions', align: 'end', sortable: false, width: '100px' },
];
</script>

<style scoped>
.addon-category-card {
  transition: all 0.2s ease;
}

.addon-category-card:hover {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

:deep(.v-data-table-header) {
  background-color: #f8fafc;
}

:deep(.v-data-table-header th) {
  font-weight: 600 !important;
  text-transform: uppercase;
  font-size: 0.75rem !important;
  letter-spacing: 0.5px;
  color: #64748b !important;
}
</style> 